import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import useSWRMutation from 'swr/mutation';
import {CreateUserEventPayload, UserEvent} from './types';

export function useCreateUserEvent() {
  return useSWRMutation<UserEvent, Error, string, CreateUserEventPayload>(
    '/api/v1/user_events/',
    async (url, {arg}) =>
      letrusAPI(url, {
        method: 'post',
        data: arg,
      }).then((response) => response.data),
    {throwOnError: false, revalidate: false},
  );
}
